/**
 * Concat socket orders according to unitPrice
 * @param {SocketOrder[]} orders
 * @param old - old contacted orders
 * @return {SocketOrder[]}
 */
export const concatOrders = (orders, old) => {
    let temp = []
    let amount = 0;
    let price = 0;
    for (let i = 0; i < orders.length; i++){
        const curr = orders[i]
        if (i === orders.length - 1) {
            amount += curr.amount
            price += curr.price
            curr.animate = isNewOrder(curr, old)
            temp.push({
                ...curr, amount: amount.toFixed(6), price
            })
            break
        }
        if (curr.priceUnit === orders[i+1].priceUnit) {
            amount += curr.amount
            price += curr.price
        }else{
            if (!amount && !price) {
                const order = {...orders[i]}
                order.animate = isNewOrder(order, old)
                temp.push(order)
            }else{
                amount += curr.amount
                price += curr.price

                curr.animate = isNewOrder(curr, old)

                // if (!curr.animate) {
                //     const probableOldItem = old?.find(c => c._id === curr._id)
                //     if (!!probableOldItem) {
                //         if (probableOldItem.price !== curr.price) {
                //             curr.animate = true
                //         }
                //     }
                // }

                temp.push({
                    ...curr, amount: amount.toFixed(6), price
                })
                amount = 0
                price = 0
            }
        }
    }

    return temp
}


const isNewOrder = (order, old) => {
    if (!old) return false
    let isNew = true
    for (let i = 0; i < old.length; i++){
        const curr = old[i]
        if (curr._id === order._id) {
            if (curr.amount !== order.amount) continue
            isNew = false
            break
        }
    }
    return isNew
}
